<template>


<!-- <div id="app"> 
</div> -->
  <loading/>
  <tab/>
  <router-view/>
  <Footers />

</template>

<script>
import tab from './components/tab.vue'
import loading from './components/loading.vue';
import Footers from '@/components/Footer.vue';

export default {
  name: 'App',
  components: {
    tab,
    loading,
    Footers
  }
}

</script>


<style lang="less">


html, body{
  padding: 0;
  margin: 0;
  background-color: #3e4037;
  overflow-x: hidden;
}

#app {
  // font-family: Avenir, Helvetica, Arial, sans-serif;
  font-family: 'AdelphiPEVF';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}


</style>
